export default {
    id: "cross-docking-2026",
    articleType: "release",
    slug: "kross-doking-na-platforme",
    date: "23 июня 2026",
    dateTime: "2026-06-23",
    modifiedTime: "2026-06-23",
    author: "Редакция «Светофор Логистика»",
    category: "Обновления платформы · 2026",
    contentType: "Функция",
    title: "На платформе «Светофор Логистика» появился кросс-докинг",
    sidebarTitle: "Новая функция: кросс-докинг",
    seoTitle: "Кросс-докинг на платформе «Светофор Логистика»",
    seoDescription:
        "В «Светофор Логистика» появился кросс-докинг — сквозное складирование, которое помогает ускорить доставку и сократить расходы на длительное хранение товаров.",
    image: "/img/news/kross-doking-na-platforme/cover.webp",
    imageAlt: "Кросс-докинг на платформе «Светофор Логистика»",
    content: {
        subtitle:
            "Новая функция помогает ускорять доставку и сокращать затраты на хранение",
        lead: [
            "На платформе «Светофор Логистика» появился кросс-докинг — сценарий, при котором товар проходит через транзитный склад без длительного хранения.",
            "Такой подход помогает отправлять продукцию от поставщика к получателю быстрее и уменьшать складские издержки.",
        ],
        sections: [
            {
                icon: "📦",
                title: "Что такое кросс-докинг",
                paragraphs: [
                    "Кросс-докинг, или сквозное складирование, — это способ перемещения товаров, при котором продукция практически не задерживается на складе. Она проходит через транзитную площадку и направляется к конечному получателю без помещения в зону длительного хранения.",
                ],
            },
            {
                icon: "⏱️",
                title: "Зачем он нужен",
                paragraphs: [
                    "Логистика и хранение могут занимать заметную долю в итоговой стоимости товара. Кросс-докинг позволяет сократить часть этих расходов и уменьшить время между поступлением товара на транзитную площадку и дальнейшей отправкой.",
                ],
                items: [
                    {
                        title: "Меньше времени на складе",
                        text: "Товар не отправляется на длительное хранение и быстрее продолжает движение по маршруту.",
                    },
                    {
                        title: "Ниже складские расходы",
                        text: "Сокращается потребность в длительном размещении и дополнительных складских операциях.",
                    },
                    {
                        title: "Быстрее доставка",
                        text: "Сквозной процесс помогает уменьшить общий цикл обработки груза.",
                    },
                ],
            },
        ],
    },
};
